var map = {
	"./development": 46089,
	"./development.js": 46089,
	"./kubes": 908658,
	"./kubes.js": 908658,
	"./production": 383191,
	"./production.js": 383191,
	"./staging": 267254,
	"./staging.js": 267254,
	"./staging2": 379406,
	"./staging2.js": 379406,
	"./test": 841725,
	"./test.js": 841725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 338391;